document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM is fully loaded and parsed!");

  mobileMenu();
});

function mobileMenu() {
  const mobileMenu = document.querySelector(".main-nav");
  const mobileMenuBtn = document.querySelector(".mobile-menu-btn");
  const mobileMenuCloseBtn = document.querySelector(".mobile-menu-close-btn");

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener("click", () => {
      mobileMenu.classList.add("nav-show");
    });
  }

  if (mobileMenuCloseBtn) {
    mobileMenuCloseBtn.addEventListener("click", () => {
      mobileMenu.classList.remove("nav-show");
    });
  }

  document.addEventListener("click", (e) => {
    const clickedInsideMenu = mobileMenu.contains(e.target);
    const clickedButton = mobileMenuBtn.contains(e.target);

    if (!clickedInsideMenu && !clickedButton) {
      mobileMenu.classList.remove("nav-show");
    }
  });
}
